module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "structure",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "bold-italic2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold-italic3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('span', {
    staticClass: "bold-italic3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote-b"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("“We are as happy as we make up our minds to be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("—Abraham Lincoln")])]), _vm._v(" "), _c('p', {
    staticClass: "quote-b"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("“You may not control all the events that happen to you, but you can decide not to be reduced by them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("—Maya Angelou ")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd03e8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_002.vue
// module id = 66
// module chunks = 0